export const MainConfig = {
    AppDetails: {
        app_name: "Sahara Express", 
        app_description: "Your App Description Here",
        app_identifier: "com.sahara.express",
        ios_app_version: "1.0.0", 
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyAEVF3iLIL9tvbj7UA5Ggw3qOxf7QOFfGA",
        authDomain: "sahara-express-fcf7f.firebaseapp.com",
        databaseURL: "https://sahara-express-fcf7f-default-rtdb.firebaseio.com",
        projectId: "sahara-express-fcf7f",
        storageBucket: "sahara-express-fcf7f.appspot.com",
        messagingSenderId: "209075811043",
        appId: "1:209075811043:web:2dd2ce92987b53106d4bd6",
        measurementId: "G-CYMXB39CKN"
    },
    Google_Map_Key: "AIzaSyAEVF3iLIL9tvbj7UA5Ggw3qOxf7QOFfGA",
    facebookAppId: "1907292452761999",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "",
        Buyer_Email_Address: ""
    }
}